import { setOverlaySessionStorage } from './set-overlay-session-storage';
import { visibleClass, hiddenClass, closedText } from '../constants';

export const closeButtonEvent = ( dialogElement, isExitOverlay ) => {
	const closeButton = dialogElement.querySelector( '[data-js-piano-overlay-close-button]' );

	if ( ! closeButton ) {
		return;
	}

	closeButton.addEventListener( 'click', () => {
		dialogElement.classList.remove( visibleClass );
		dialogElement.classList.add( hiddenClass );
		isExitOverlay && dialogElement.close();
		setOverlaySessionStorage( dialogElement, closedText );
	} );
};
export default closeButtonEvent;
